export default __webpack_public_path__ + "static/media/logo.d623f13a.png";